export const getEuroFromCentValue = (value: number) => parseFloat((value / 100).toFixed(2));
